import React, { useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useDispatch, useSelector } from "react-redux";
import MeIcon from "../../../../components/icon/index"

export default props =>{
    useStyles(cls);
    const { checkoutLoginStatus, customer } = props;
    const global = useSelector(state=>state.global);

    const checkoutLoginHandle = useCallback((evt, path, difference) =>{
        evt.preventDefault();
        checkoutLoginStatus(path, difference);
    }, [customer]);
  
    return <div className={cls.TopMeIcon}>
        <div>
            <MeIcon icon="&#xe70b;" to="/user/notification" className={cls.IconSize24} count={global?.countNotification} handleClick={checkoutLoginHandle} />
        </div>

        <div className={cls.Right}>
            <MeIcon icon="&#xe6a2;" to="/user/wishlist" handleClick={checkoutLoginHandle} />
            <MeIcon icon="&#xe6a4;" href="/cart" count={global?.countCart} handleClick={()=>{}} />
            <MeIcon icon="&#xe6e6;" to="/user/settings" handleClick={checkoutLoginHandle} />
        </div>
    </div>
}
